import React from "react";
import Header from "./Header/Header";
import Works from "./Works/Works";

const Home = () => {
  return (
    <>
      <Header />
      <Works />
    </>
  );
};

export default Home;
